'use strict';

/**
 * sex
 * 性别
 * @param str
 * @param mode
 * 0 [0-日,6-六]
 * 1 [1-一,7-天]
 * @returns {*}
 */

module.exports = function (str) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (str === undefined) return "";
  var ws = ['日', '一', '二', '三', '四', '五', '六', "天"];
  switch (mode) {
    case 0:
      return '周' + ws[str];
      break;
    case 1:
      return '星期' + ws[str];
      break;
    default:
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ty-vue-filters@1.0.22@ty-vue-filters/dist/filters/week.js
// module id = fPxk
// module chunks = 300